module.exports = __webpack_public_path__ + "static/img/nav_2.81f958c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/comm/images/document-conversion/homeSVG/nav_2.svg
// module id = sSrt
// module chunks = 2